import React, { useState } from 'react';

import './SaveSearchModal.scss';

const SaveSearchModal = ({ isOpen, onClose, onSave, filters }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  if (!isOpen) return null;

  const buildSuggestion = () => {
    const parts = [];
    if (filters.graduationYear && filters.graduationYear !== 'Filter all') {
      parts.push(filters.graduationYear);
    }
    if (filters.sport) parts.push(filters.sport);
    if (filters.gender) parts.push(filters.gender);
    if (filters.position && filters.position !== 'Filter all') {
      parts.push(filters.position);
    }
    return parts.join(' · ') || 'My Search';
  };

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Please enter a name for this search.');
      return;
    }
    if (trimmed.length > 100) {
      setError('Name must be 100 characters or less.');
      return;
    }
    setError('');
    setIsSaving(true);
    try {
      await onSave(trimmed, filters);
      setName('');
      onClose();
    } catch (err) {
      setError(
        err?.response?.data?.message || 'Failed to save search. Please try again.'
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !isSaving) {
      handleSave();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="ssm__overlay" onClick={onClose}>
      <div className="ssm__modal" onClick={e => e.stopPropagation()}>
        <div className="ssm__header">
          <h3 className="ssm__title">
            <i className="fas fa-bookmark" /> Save This Search
          </h3>
          <button
            type="button"
            className="ssm__close"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="ssm__body">
          <label className="ssm__label" htmlFor="search-name">
            Search Name
          </label>
          <input
            id="search-name"
            className="ssm__input"
            type="text"
            placeholder={buildSuggestion()}
            value={name}
            onChange={e => {
              setName(e.target.value);
              if (error) setError('');
            }}
            onKeyDown={handleKeyDown}
            maxLength={100}
            autoFocus
          />
          {error && <span className="ssm__error">{error}</span>}

          <div className="ssm__preview">
            <span className="ssm__preview-label">Filters:</span>
            <span className="ssm__preview-value">
              {[
                filters.sport,
                filters.gender,
                filters.graduationYear !== 'Filter all'
                  ? filters.graduationYear
                  : null,
                filters.position !== 'Filter all' ? filters.position : null,
              ]
                .filter(Boolean)
                .join(' · ') || 'All'}
            </span>
          </div>
        </div>

        <div className="ssm__actions">
          <button
            type="button"
            className="ssm__btn ssm__btn--cancel"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="ssm__btn ssm__btn--save"
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Saving…
              </>
            ) : (
              <>
                <i className="fas fa-check" /> Save
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveSearchModal;
